import React from "react";
import { toast } from "sonner";
import { Share2, Copy, ExternalLink, Eye, ShieldCheck } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function ShareStore() {
  const { user } = useAuth();
  const url = `${window.location.origin}/store/${user?.id}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("تم نسخ الرابط");
    } catch {
      window.prompt("انسخ الرابط:", url);
    }
  };

  return (
    <div className="max-w-3xl mx-auto space-y-6" data-testid="share-store-page">
      <div>
        <h1 className="text-3xl md:text-4xl font-extrabold text-[#333333] flex items-center gap-2">
          <Share2 className="text-[#09637E]" size={32} /> مشاركة الموقع
        </h1>
        <p className="text-[#666666] mt-1">صفحة عامة لمتجرك تعرض منتجاتك وأسعارك لأي شخص دون تسجيل دخول</p>
      </div>

      <div className="bg-white border border-[#7AB2B2] rounded-2xl p-5 md:p-6 space-y-4">
        <div>
          <div className="text-sm font-bold text-[#333333] mb-2">رابط موقعك العام</div>
          <div className="min-h-12 py-3 rounded-lg border border-[#7AB2B2] bg-[#EBF4F6] px-4 flex items-center" dir="ltr">
            <span className="font-mono text-xs sm:text-sm text-[#09637E] break-all leading-relaxed" data-testid="share-store-url">{url}</span>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
          <button onClick={copy} data-testid="share-store-copy"
            className="h-12 rounded-lg bg-[#09637E] hover:bg-[#088395] text-white font-extrabold flex items-center justify-center gap-2">
            <Copy size={18} /> نسخ الرابط
          </button>
          <a href={url} target="_blank" rel="noopener noreferrer" data-testid="share-store-open"
            className="h-12 rounded-lg border-2 border-[#09637E] text-[#09637E] font-extrabold flex items-center justify-center gap-2 hover:bg-[#EBF4F6]">
            <ExternalLink size={18} /> فتح الموقع
          </a>
        </div>
      </div>

      <div className="bg-[#EBF4F6] border border-[#7AB2B2] rounded-2xl p-5 text-sm text-[#333333] space-y-2" data-testid="share-store-info">
        <div className="flex items-start gap-2"><Eye size={16} className="mt-0.5 text-[#09637E] shrink-0" /> تظهر للزوار: اسم المحل، المدينة، صور المنتجات، الأسعار، المقاس، المنشأ، اللون، الشركة المصنعة، كود المنتج، وحالة التوفر.</div>
        <div className="flex items-start gap-2"><ShieldCheck size={16} className="mt-0.5 text-[#09637E] shrink-0" /> لا تظهر أبداً: اسمك الشخصي، بريدك، هاتفك، عنوانك التفصيلي، الكميات، الإحصائيات أو أي بيانات مالية.</div>
        <div className="text-xs text-[#666666]">أي تعديل على منتجاتك أو أسعارك يظهر مباشرة في الصفحة العامة.</div>
      </div>
    </div>
  );
}
